'use client';

import { FC, ReactNode } from 'react';
import { useResponsive } from '../../hooks/use-responsive';

export const Responsive: FC<{
  sm?: ReactNode;
  lg?: ReactNode;
  xl?: ReactNode;
  xl2?: ReactNode;
  xl3?: ReactNode;
  loading?: ReactNode;
  children?: ReactNode;
}> = ({ children, sm, lg, xl, xl2, xl3, loading }) => {
  const breakpoint = useResponsive();
  if (!breakpoint.isHydrated) {
    return <>{loading}</>;
  }
  if (xl3 && breakpoint.xl3) return <>{xl3}</>;
  if (xl2 && breakpoint.xl2) return <>{xl2}</>;
  if (xl && breakpoint.xl) return <>{xl}</>;
  if (lg && breakpoint.lg) return <>{lg}</>;
  if (sm && breakpoint.sm) return <>{sm}</>;
  return <>{children}</>;
};

export const Mobile = ({
  children,
  fallback,
  loading,
}: {
  children: ReactNode;
  fallback?: ReactNode;
  loading?: ReactNode;
}) => {
  return (
    <Responsive sm={fallback} loading={loading}>
      {children}
    </Responsive>
  );
};
